import { FC } from "react";
import { Button, ButtonVariant, Modal } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { InfoCircle } from "untitledui-js-base";

type DeleteTemplateModalProps = {
  opened: boolean;
  setShowDeleteModal: (show: boolean) => void;
  handleDelete: () => void;
};

export const DeleteTemplateModal: FC<DeleteTemplateModalProps> = ({
  opened,
  setShowDeleteModal,
  handleDelete
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const handleCancel = (e: any) => {
    e.stopPropagation();
    setShowDeleteModal(false);
  };

  const onDelete = (e: any) => {
    e.stopPropagation();
    handleDelete();
    setShowDeleteModal(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setShowDeleteModal(false);
      }}
      panelClassName="w-full max-w-[375px] overflow-auto p-6"
    >
      <div className="grid place-items-center pb-4">
        <div className="grid w-min place-items-center rounded-full bg-danger-50 p-4">
          <InfoCircle size="32px" className="stroke-danger-500" />
        </div>
      </div>
      <div className="flex items-center justify-between pb-4">
        <div className="text-center text-xl font-bold text-content-1000">
          Are you sure you want to delete this template?
        </div>
      </div>
      <div className="rounded-lg bg-danger-50 p-4">
        <ul className="mb-4 list-disc pl-5">
          <li className="mb-2 text-sm text-danger-600">
            Deletions do not affect current applications
          </li>
          <li className=" mb-2 text-sm text-danger-600">
            {dictionary.Properties} that use this template will revert to
            default screening settings
          </li>
        </ul>
      </div>
      <div className="mt-4 flex gap-2.5">
        <div className="w-full">
          <Button
            variant={ButtonVariant.BASE}
            onClick={(e: any) => handleCancel(e)}
            className="w-full"
          >
            Cancel
          </Button>
        </div>
        <div className="w-full">
          <Button
            className="w-full"
            variant={ButtonVariant.DANGER}
            onClick={(e: any) => onDelete(e)}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
